export class DataFileAccessDto {
  contactId = 0;
}
